import InventoryFilterArrayFilter from './InventoryFilterArrayFilter';

export default InventoryFilterArrayFilter;
export { InventoryFilterArrayFilter };
